// Backend client abstraction - legacy compatibility layer
// For new code, use: import { apiClient } from "@/lib/api-client";
import { apiClient } from '@/lib/api-client';

export const supabase = apiClient;